import React from 'react';
import { Input, Checkbox, Form, Space } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import { updateWorkflowCreatePayload } from '../../../../store/workflows/slice';
import TagsFamily from './TagsFamily';

const formItemStyle: React.CSSProperties = {
  border: '1px solid #F4F4F4',
  background: '#FFFFFF',
  borderRadius: 20,
  padding: 16,
};

const JobInfo = () => {
  const dispatch = useAppDispatch();
  const workflowPayload = useAppSelector(state => state.workflows.workflowCreatePayload);

  const jobName = workflowPayload?.name || '';
  const qcNeeded = workflowPayload?.qcNeeded ?? true;
  const descriptionNeeded = workflowPayload?.descriptionNeeded || false;
  const tagFamily = workflowPayload?.tagFamily || [];

  const handleJobNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      updateWorkflowCreatePayload({
        name: e.target.value,
      }),
    );
  };

  const handleQcNeededChange = (checked: boolean) => {
    dispatch(
      updateWorkflowCreatePayload({
        qcNeeded: checked,
      }),
    );
  };

  const handleDescriptionNeededChange = (checked: boolean) => {
    dispatch(
      updateWorkflowCreatePayload({
        descriptionNeeded: checked,
      }),
    );
  };

  const handleTagFamilyChange = (tags: Array<any>) => {
    dispatch(
      updateWorkflowCreatePayload({
        tagFamily: tags,
      }),
    );
  };

  return (
    <Form layout="vertical" requiredMark={false}>
      <Form.Item label="Job Name" required style={formItemStyle}>
        <Input
          placeholder="Enter job name"
          value={jobName}
          onChange={handleJobNameChange}
          style={{
            border: '1px solid #F4F4F4',
            borderRadius: 8,
          }}
        />
      </Form.Item>

      <TagsFamily data={tagFamily} onChange={handleTagFamilyChange} />

      <Form.Item label="Additional Requirements" style={formItemStyle}>
        <Space direction="vertical">
          <Checkbox
            checked={descriptionNeeded}
            onChange={e => handleDescriptionNeededChange(e.target.checked)}
          >
            Add description with the tag
          </Checkbox>
          <Checkbox checked={qcNeeded} onChange={e => handleQcNeededChange(e.target.checked)}>
            QC needed before publishing
          </Checkbox>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default JobInfo;
